<template>
    <vxe-modal
        v-model="isShow"
        :title="title"
        width="1000"
        height="600"
        show-zoom
        resize
    >
        <div class="modal-wrapper">
            <!-- 自定义 loading -->
            <div v-if="submitting" class="loading-mask">
                <div class="loading-box">
                    <i class="vxe-icon-spinner roll"></i>
                    <span>正在估算功能点，请稍候...</span>
                </div>
            </div>
            <div>
                <div>
                    <vxe-form :data="toolbar.formData">
                        <vxe-form-item>
                            <template #default>
                                <vxe-button
                                    @click="createRow"
                                    v-if="!toolbar.formData.viewOnly"
                                    >新增</vxe-button
                                ></template
                            ></vxe-form-item
                        >
                        <vxe-form-item title="FP(功能点数)合计" field="totalFP">
                            <template #default="{ data }">
                                <vxe-input
                                    :model-value="data.totalFP"
                                    placeholder="0"
                                    style="width: 100px"
                                    readonly
                                ></vxe-input>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="估算文件"
                            field="fEstimateFile"
                            v-if="!toolbar.formData.viewOnly"
                        >
                            <template #default="{ data }">
                                <vxe-input
                                    v-model="data.fEstimateFile"
                                    placeholder="请输入估算文件"
                                    clearable
                                    readonly
                                    v-if="!toolbar.formData.viewOnly"
                                ></vxe-input>
                                <vxe-button
                                    @click="browseFile"
                                    v-if="!toolbar.formData.viewOnly"
                                    >浏览</vxe-button
                                >
                            </template>
                        </vxe-form-item>
                        <vxe-form-item>
                            <template #default>
                                <vxe-button
                                    status="success"
                                    @click="estimateFP"
                                    @keyup.enter="estimateFP"
                                    v-if="!toolbar.formData.viewOnly"
                                    >开始估算</vxe-button
                                >
                                <vxe-button
                                    @click="confirmData"
                                    status="primary"
                                    v-if="!toolbar.formData.viewOnly"
                                    >确认</vxe-button
                                >
                            </template>
                        </vxe-form-item>
                        <vxe-form-item title="">
                            <a
                                href="javascript:void(0);"
                                @click="downloadFPTemplate()"
                                v-if="!toolbar.formData.viewOnly"
                                >下载估算模板</a
                            >
                        </vxe-form-item>
                    </vxe-form>
                </div>
                <div style="overflow: hidden; height: 100%">
                    <vxe-table
                        stripe
                        class="mytable-scrollbar"
                        :data="tableData"
                        :height="tableHeight"
                        show-overflow
                        :row-config="{
                            height: 36,
                            isHover: true,
                            isCurrent: true,
                        }"
                        ref="xTable1"
                    >
                        <vxe-column
                            type="seq"
                            field="Id"
                            title="序号"
                            width="50"
                        ></vxe-column>
                        <vxe-column
                            title="删除"
                            width="50"
                            v-if="!toolbar.formData.viewOnly"
                        >
                            <template #default="{ row }">
                                <vxe-button
                                    type="text"
                                    icon="fa fa-trash-o"
                                    @click="removeRowEvent(row)"
                                ></vxe-button>
                            </template>
                        </vxe-column>
                        <vxe-column
                            title="编辑"
                            width="50"
                            v-if="!toolbar.formData.viewOnly"
                        >
                            <template #default="{ row }">
                                <vxe-button
                                    type="text"
                                    icon="fa fa-edit"
                                    @click="editRow(row)"
                                ></vxe-button>
                            </template>
                        </vxe-column>
                        <vxe-column
                            field="RequirementModule"
                            title="需求模块"
                            width="180"
                            show-overflow
                            resizable
                            sortable
                        ></vxe-column>
                        <vxe-column
                            field="DataFunctionName"
                            title="数据功能名称"
                            width="140"
                            sortable
                        ></vxe-column>
                        <vxe-column
                            field="FunctionType"
                            title="功能类型"
                            width="100"
                            sortable
                        ></vxe-column>
                        <vxe-column
                            field="ChangeType"
                            title="修改类型"
                            width="100"
                            show-overflow
                            resizable
                        ></vxe-column>
                        <vxe-column
                            field="FunctionPoint"
                            title="功能点数"
                            width="100"
                            show-overflow
                            resizable
                        ></vxe-column>
                        <vxe-column
                            field="Reason"
                            title="理由"
                            sortable
                        ></vxe-column>
                    </vxe-table>
                </div>
            </div>
        </div>
    </vxe-modal>
    <!--编辑功能点评估-->
    <vxe-modal
        v-model="formInput.isShow"
        @close="closeWinEvent"
        :title="formInput.title || '编辑功能点评估'"
        width="840"
        height="450"
        show-zoom
        resize
        remember
        show-footer
    >
        <template #default>
            <vxe-form
                :data="formInput.formData"
                :rules="formInput.formRules"
                title-align="right"
                ref="rForm"
                title-width="120"
            >
                <vxe-form-item
                    title="需求模块"
                    field="RequirementModule"
                    span="12"
                >
                    <template #default>
                        <vxe-input
                            v-model="formInput.formData.RequirementModule"
                            placeholder="请输入需求模块"
                        ></vxe-input>
                    </template>
                </vxe-form-item>

                <vxe-form-item
                    title="数据功能名称"
                    field="DataFunctionName"
                    span="12"
                >
                    <template #default>
                        <vxe-input
                            v-model="formInput.formData.DataFunctionName"
                            placeholder="请输入数据功能名称"
                        ></vxe-input>
                    </template>
                </vxe-form-item>

                <vxe-form-item title="功能类型" field="FunctionType" span="12">
                    <template #default>
                        <vxe-select
                            v-model="formInput.formData.FunctionType"
                            placeholder="请选择功能类型"
                            clearable
                            @change="onSelectFPType"
                        >
                            <vxe-option
                                value="ILF"
                                label="ILF(内部逻辑文件)"
                            ></vxe-option>
                            <vxe-option
                                value="EIF"
                                label="EIF(外部接口文件)"
                            ></vxe-option>
                        </vxe-select>
                    </template>
                </vxe-form-item>

                <vxe-form-item title="修改类型" field="ChangeType" span="12">
                    <template #default>
                        <vxe-select
                            v-model="formInput.formData.ChangeType"
                            placeholder="请选择修改类型"
                            clearable
                            @change="onSelectFPType"
                        >
                            <vxe-option value="新增" label="新增"></vxe-option>
                            <vxe-option value="修改" label="修改"></vxe-option>
                            <vxe-option value="删除" label="删除"></vxe-option>
                        </vxe-select>
                    </template>
                </vxe-form-item>

                <vxe-form-item title="功能点数" field="FunctionPoint" span="12">
                    <template #default>
                        <vxe-input
                            v-model="formInput.formData.FunctionPoint"
                            type="number"
                            min="0"
                            placeholder="请输入功能点数"
                            readonly
                        ></vxe-input>
                    </template>
                </vxe-form-item>
                <vxe-form-item title="序号" field="seq" span="12" v-if="false">
                    <template #default>
                        <vxe-input
                            v-model="formInput.formData.seq"
                            type="number"
                            min="1"
                            placeholder="请输入序号"
                        ></vxe-input>
                    </template>
                </vxe-form-item>
                <vxe-form-item title="理由" field="Reason" span="24">
                    <template #default>
                        <vxe-textarea
                            v-model="formInput.formData.Reason"
                            placeholder="请输入理由"
                            rows="4"
                            maxlength="500"
                            show-word-count
                        ></vxe-textarea>
                    </template>
                </vxe-form-item>
            </vxe-form>
        </template>

        <template #footer>
            <div style="text-align: center; width: 100%">
                <vxe-button @click="closeWinEvent">取消</vxe-button>
                <vxe-button status="primary" @click="saveEvent">
                    保存
                </vxe-button>
            </div>
        </template>
    </vxe-modal>
</template>

<script setup>
import {
    reactive,
    ref,
    getCurrentInstance,
    defineExpose,
    defineEmits,
    onMounted,
    computed,
    watch,
} from "vue";
import { VXETable } from "vxe-table";
import Qs from "qs";
import XEUtils from "xe-utils";
import { useRouter } from "vue-router";
const router = useRouter();
const { proxy } = getCurrentInstance();
const emit = defineEmits(["updateTotal"]);
const tableHeight = ref(420);
const tableData = ref([]);
let oneEstimateFile = ref({}); //上传的附件
const isShow = ref(false);
const title = ref("FP功能点数估算");
const submitting = ref(false);
const tablePager = reactive({
    currentPage: 1,
    pageSize: 1000,
    totalResult: 0,
});

const toolbar = reactive({
    loading: false,
    formData: {
        fEstimateFile: "", //文件名
        totalFP: 0, //FP合计
        reqID: "", //需求ID
        projectName: "", //项目名称
        viewOnly: true,
    },
});
const formInput = reactive({
    isShow: false,
    title: "编辑功能点评估",
    formData: {
        Id: "",
        reqId: "",
        RequirementModule: "",
        DataFunctionName: "",
        FunctionType: "",
        ChangeType: "",
        FunctionPoint: null,
        Reason: "",
        seq: 0,
        CreationTime: "",
    },
    formRules: {
        reqId: [{ required: true, message: "请输入 reqId" }],
        RequirementModule: [{ required: true, message: "请输入需求模块" }],
        DataFunctionName: [{ required: true, message: "请输入数据功能名称" }],
        FunctionType: [{ required: true, message: "请选择功能类型" }],
        ChangeType: [{ required: true, message: "请选择变更类型" }],
        FunctionPoint: [{ required: true, message: "请输入功能点数" }],
        Reason: [{ required: true, message: "请输入理由" }],
        seq: [{ required: false, message: "请输入序号" }],
    },
});
const findData = () => {
    const params = {
        uid: proxy.$store.state.userID,
        email: proxy.$store.state.email,
        currentPage: tablePager.currentPage,
        pageSize: tablePager.pageSize,
        searchKey: [toolbar.formData.reqID],
    };
    proxy.$api.newRequireManageAPI
        .getEstimateFPList(Qs.stringify(params))
        .then((res) => {
            if (res.data.Success == false) {
                VXETable.modal.message({
                    content: res.data.Message,
                    status: "error",
                });
                return;
            }
            // console.log(res.data.Data);
            tableData.value = res.data.Data.dataTable;
            tablePager.currentPage = res.data.Data.currentPage;
            tablePager.pageSize = res.data.Data.pageSize;
            tablePager.totalResult = res.data.Data.totalResult;
        })
        .catch((error) => {
            console.log(error);
        });
};
const browseFile = async () => {
    const { files } = await VXETable.readFile(false);

    if (!files || files.length === 0) {
        toolbar.formData.fEstimateFile = "";
        oneEstimateFile.value = {};
        return;
    }

    Array.from(files).forEach((file) => {
        toolbar.formData.fEstimateFile = file.name;
        oneEstimateFile.value = file;
    });
};
const handlePageChange = (params) => {
    tablePager.currentPage = params.currentPage;
    tablePager.pageSize = params.pageSize;
    findData();
};
const editRow = (row) => {
    formInput.title = "编辑功能点数";
    formInput.formData = {
        Id: row.Id,
        reqId: row.reqId,
        RequirementModule: row.RequirementModule,
        DataFunctionName: row.DataFunctionName,
        FunctionType: row.FunctionType,
        ChangeType: row.ChangeType,
        FunctionPoint: row.FunctionPoint,
        Reason: row.Reason,
        seq: row.seq,
        CreationTime: row.CreationTime,
    };
    formInput.isShow = true;
};
const createRow = () => {
    formInput.title = "新增功能点数";
    formInput.formData.Id = 0;
    formInput.formData.reqId = toolbar.formData.reqID;
    formInput.formData.RequirementModule = "";
    formInput.formData.DataFunctionName = "";
    formInput.formData.FunctionType = "";
    formInput.formData.ChangeType = "";
    formInput.formData.FunctionPoint = null;
    formInput.formData.Reason = "";
    formInput.formData.seq = null;
    formInput.isShow = true;
};
//保存估算
const saveEvent = async () => {
    const $form = proxy.$refs.rForm;
    if ($form) {
        const errMap = await $form.validate().catch((err) => err);
        if (errMap) {
            return;
        }
    }

    const payload = {
        Id: formInput.formData.Id,
        reqId: formInput.formData.reqId,
        RequirementModule: formInput.formData.RequirementModule,
        DataFunctionName: formInput.formData.DataFunctionName,
        FunctionType: formInput.formData.FunctionType,
        ChangeType: formInput.formData.ChangeType,
        FunctionPoint: Number(formInput.formData.FunctionPoint) || 0,
        Reason: formInput.formData.Reason,
        seq: Number(formInput.formData.seq) || 1,
        CreationTime: formInput.formData.CreationTime,
    };

    console.log("提交数据", payload);
    if (formInput.formData.Id == 0) {
        proxy.$api.newRequireManageAPI
            .addFPEstimate(Qs.stringify(payload))
            .then((res) => {
                if (res.data.Success == false) {
                    VXETable.modal.message({
                        content: res.data.Message,
                        status: "error",
                    });
                    return;
                }
                VXETable.modal.message({
                    content: "新增成功",
                    status: "success",
                });
                findData();
            })
            .catch((error) => {
                console.log(error);
            });
    } else {
        // 这里调用接口
        proxy.$api.newRequireManageAPI
            .updateFPEstimate(Qs.stringify(payload))
            .then((res) => {
                if (res.data.Success == false) {
                    VXETable.modal.message({
                        content: res.data.Message,
                        status: "error",
                    });
                    return;
                }
                VXETable.modal.message({
                    content: "保存成功",
                    status: "success",
                });
                findData();
            })
            .catch((error) => {
                console.log(error);
            });
    }

    formInput.isShow = false;
};
const downloadFPTemplate = (params) => {
    const payload = {
        reqID: toolbar.formData.reqID,
    };
    proxy.$api.newRequireManageAPI
        .downloadFPTemplate(Qs.stringify(payload))
        .then((res) => {
            if (res.data.Success == false) {
                VXETable.modal.message({
                    content: res.data.Message,
                    status: "error",
                });
                return;
            }
            let url = res.data.Data;
            const link = document.createElement("a");
            link.href = url;
            link.download = getFileName();
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        })
        .catch((error) => {
            console.log(error);
        });
};
const getFileName = (ext = "xlsx") => {
    const timestamp = Date.now();
    const random = Math.floor(Math.random() * 100000);
    return `${timestamp}_${random}.${ext}`;
};
const removeRowEvent = async (row) => {
    const type = await VXETable.modal.confirm("确定要删除该行估算吗？");

    if (type === "confirm") {
        const payload = {
            Id: row.Id,
        };
        proxy.$api.newRequireManageAPI
            .delFPEstimate(Qs.stringify(payload))
            .then((res) => {
                if (res.data.Success == false) {
                    VXETable.modal.message({
                        content: res.data.Message,
                        status: "error",
                    });
                    return;
                }
                VXETable.modal.message({
                    content: "删除成功",
                    status: "success",
                });
                findData();
            })
            .catch((error) => {
                console.log(error);
            });
    }
};

const estimateFP = () => {
    submitting.value = true;
    console.log(toolbar.formData.reqID);
    const data = new FormData();
    data.append("projectName", toolbar.formData.projectName);
    data.append("reqID", toolbar.formData.reqID);
    data.append("estimateFile", oneEstimateFile.value);
    proxy.$api.newRequireManageAPI
        .estimateFP(data)
        .then((res) => {
            if (res.data.Success == false) {
                submitting.value = false;
                VXETable.modal.alert({
                    content: res.data.Message,
                    status: "error",
                });
                return;
            }
            console.log(res.data.Data);
            submitting.value = false;
            VXETable.modal.message({
                content: "估算成功",
                status: "success",
            });
            toolbar.formData.fEstimateFile = "";
            findData();
        })
        .catch((error) => {
            submitting.value = false;
            VXETable.modal.alert({ content: error, status: "error" });
            console.log(error);
        });
};
const onSelectFPType = () => {
    if (formInput.formData.FunctionType && formInput.formData.ChangeType) {
        let FPCount = calculateFP(
            formInput.formData.FunctionType,
            formInput.formData.ChangeType
        );
        formInput.formData.FunctionPoint = FPCount;
    }
};
const calculateFP = (type, action) => {
    const rules = {
        ILF: {
            新增: 35,
            修改: 24.5,
            删除: 7,
        },
        EIF: {
            新增: 15,
            修改: 10.5,
            删除: 5,
        },
    };

    if (!rules[type]) {
        throw new Error(`不支持的类型: ${type}`);
    }

    if (!rules[type][action]) {
        throw new Error(`不支持的操作: ${action}`);
    }

    return rules[type][action];
};
const openModal = async (reqId, projectName, viewOnly = true) => {
    isShow.value = true;
    tablePager.currentPage = 1;
    toolbar.formData.reqID = reqId;
    toolbar.formData.projectName = projectName;
    toolbar.formData.viewOnly = viewOnly;
    console.log(toolbar.formData);
    findData();
};
const closeWinEvent = () => {
    formInput.isShow = false;
};
const isAdmin = ref(false);
onMounted(() => {
    isAdmin.value = proxy.$store.state.isAdmin == "1";
});
toolbar.formData.totalFP = computed(() => {
    return tableData.value.reduce((sum, row) => {
        return sum + (Number(row.FunctionPoint) || 0);
    }, 0);
});
const confirmData = () => {
    emit("updateTotal", toolbar.formData.totalFP);
    isShow.value = false;
};
watch(
    () => toolbar.formData.fEstimateFile,
    (val) => {
        if (!val) {
            oneEstimateFile.value = {};
        }
    }
);
defineExpose({ openModal });
</script>

<style lang="scss" scoped>
.mytable-style .vxe-body--column.col-red {
    background-color: red;
    color: #fff;
}

.active {
    color: green;
}

.error {
    color: red;
}

.audit {
    color: blue;
}
.modal-wrapper {
    position: relative;
    height: 100%;
}

.loading-mask {
    position: absolute;
    inset: 0;
    background: rgba(255, 255, 255, 0.7);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10;
}

.loading-box {
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 14px;
    color: red;
}
</style>

<style type="text/css">
td.vxe-body--column {
    vertical-align: middle;
}
</style>
